import React from 'react';
import HomeStyle from '../../styles/home.style';
import { Translate } from 'react-localize-redux';
import { NavLink } from "react-static";

class ContactPanel extends React.Component{

  constructor(props){
    super(props);
    this.state = {}
  }

  render(){

    const pageType = this.props.option;

    return (
      <HomeStyle className="xs-12">
        <section className="xs-12" id="coffee">
          <div className="xs-12 coffee-h t-c">
            <div className="c-w">
              <div className="c">
                <div className="xs-10 xs-off-1">
                  {pageType ? <div>
                    <h2> <Translate id="home.revolution.two" /></h2>
                    <p>  <Translate id="home.revolutionText.two" />  </p>
                    </div> : <div>
                    <h2> <Translate id="home.revolution.one" /></h2>
                    <p>  <Translate id="home.revolutionText.one" />  </p>
                    </div>}

                  <NavLink
                    className="btn-inverse"
                    id="nous"
                    to="/contact-us"
                  >
                    <Translate id="home.buttons.contact" />
                  </NavLink>

                </div>
              </div>
            </div>
          </div>
        </section>
      </HomeStyle>
    )
  }

}

export default ContactPanel;



// WEBPACK FOOTER //
// /opt/build/repo/src/shared-components/contact-panel/index.js